import React from 'react';

// Actions
import { AUTHORIZE_EMAIL, REMOVE_EMAIL, removeEmail } from '@/redux/modules/omni-risk-profiles';

// Components
import { SharedEmailItem } from './components/SharedEmailItem';

// Hooks
import { useLoadingUIState } from '@/hooks/useLoadingState';

// Libraries
import { Dispatch } from '@/redux';
import { useDispatch } from 'react-redux';

// Types
import { FormattedFullOmniRiskProfile } from '@/types/risk-profiles/omni/full-omni-risk-profile';

// Utils
import notification from '@/utils/notification';
import { formatMessage } from '@/utils/i18n';
import { DATE_KEYS, sortByDateKey } from '@/utils/dates';

interface SharedEmailsProps {
  authorizeEmail: (email: string) => Promise<void>;
  riskProfile: FormattedFullOmniRiskProfile;
}

export const SharedEmails: React.FC<SharedEmailsProps> = ({ authorizeEmail, riskProfile }) => {
  const { emails = [] } = riskProfile;
  const dispatch = useDispatch<Dispatch>();
  const isAuthorizingEmail = useLoadingUIState(AUTHORIZE_EMAIL.type);
  const isRemovingEmail = useLoadingUIState(REMOVE_EMAIL.type);
  const riskProfileEmail = emails[0]?.email || '';

  const handleRemoveEmail = async (email: string, riskProfile: FormattedFullOmniRiskProfile) => {
    await dispatch(removeEmail(email, riskProfile));
    notification.success(
      formatMessage('RiskProfileModal.SendQuestionnaire.RemovedAccessBody'),
      formatMessage('RiskProfileModal.SendQuestionnaire.RemovedAccessTitle'),
    );
  };

  // If the conditions for rendering the SharedEmails component are not met, return null.
  if (!riskProfileEmail) {
    return null;
  }

  return (
    <div className="contacts-container" data-testid="sendQuestionnaire-contacts-container">
      {[emails.sort((a, b) => sortByDateKey(a, b, DATE_KEYS.SENT_AT))[0]].map(({ email, sentAt }) => (
        <SharedEmailItem
          authorizeEmail={authorizeEmail}
          email={email}
          isAuthorizing={isAuthorizingEmail}
          isRemoving={isRemovingEmail}
          key={email}
          removeEmail={handleRemoveEmail}
          riskProfile={riskProfile}
          sentAt={sentAt}
        />
      ))}
    </div>
  );
};
